export default __webpack_public_path__ + "static/media/profile.5433089b.png";